
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Link from "next/link";
const Attributes = ({ t }) => {
    const attributes = t('home:attributes', {}, { returnObjects: true });
    const AttrItem = ({ slide, i }) => {
        return <Link className={'attributes_list_item'} href={slide.url}>
            <picture>
                <source srcSet={`/img/pages/home/banner/icon_${slide.icon}.webp`} type="image/webp"/>
                <source srcSet={`/img/pages/home/banner/icon_${slide.icon}.png`}/>
                <img src={`/img/pages/home/banner/icon_${slide.icon}.png`} alt={`ColdWare ${slide.title}`} width={96} height={96} className='slide_icon'/>
            </picture>
            <div className={'img_wrapper'}>
                <picture>
                    {/*<source*/}
                    {/*    media="(max-width: 768px)"*/}
                    {/*    srcSet={`/img/pages/home/attributes/attr_${slide.img}_small.webp`}*/}
                    {/*    type="image/webp"*/}
                    {/*/>*/}
                    <source media="(min-width: 769px)" srcSet={`/img/pages/home/attributes/attr_${slide.img}.webp`} type="image/webp"/>
                    {/*<source*/}
                    {/*    media="(max-width: 768px)"*/}
                    {/*    srcSet={`/img/pages/home/attributes/attr_${slide.img}_small.png`}*/}
                    {/*/>*/}
                    <source media="(min-width: 769px)" srcSet={`/img/pages/home/attributes/attr_${slide.img}.png`}/>
                    <img src={`/img/pages/home/attributes/attr_${slide.img}.png`} alt={`ColdWare ${slide.title}`} width={176} height={723} className='slide_img'/>
                </picture>
            </div>
            <h3 className={'slide_title'}>{slide.title}</h3>
            <p className={'slide_description'}>{slide.description}</p>
        </Link>;
    };
    return (<>
            <div className="container">
                <div className={'attributes_title'}>
                    <h2>{attributes.title}</h2>
                    <p>{attributes.description}</p>
                </div>
            </div>
            <section className={'attributes'}>
                <div className="container attributes_list">
                    {attributes.items.map((slide, i) => {
            return <AttrItem key={slide.key} slide={slide} i={i}/>;
        })}
                </div>
            </section>
        </>);
};
export default Attributes;

    async function __Next_Translate__getStaticProps__19763359603__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//home/Attributes/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19763359603__ as getStaticProps }
  